import { CommonModule } from '@angular/common';
import { NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ColorPickerModule } from 'ngx-color-picker';

import { IconComponent } from '@app/shared/components/icon/icon.component';
import { MaterialCustomModule } from 'v2/material-custom.module';
import { FilterModule } from 'v2/modules/filter/filter.module';
import { RfqModule } from 'v2/modules/rfq/rfq.module';
import { DirectiveModule } from 'v2/modules/shared/directives/directive.module';
import { PipeModule } from 'v2/modules/shared/pipes/pipe.module';
import { UiModule } from 'v2/modules/ui/ui.module';
import { SharedComponentsModule } from 'v2/shared-components.module';

import {
  AutomationRuleComponent,
  AutomationRuleFormComponent,
  AutomationRuleTableComponent,
  AutomationRuleConditionFormComponent,
  AutomationRuleActionFormComponent,
} from './components';

const angularModules = [
  CommonModule,
  MaterialCustomModule,
  ReactiveFormsModule,
  FormsModule,
];
const lumModules = [
  DirectiveModule,
  FilterModule,
  PipeModule,
  SharedComponentsModule,
  UiModule,
  RfqModule,
];
const components = [
  AutomationRuleComponent,
  AutomationRuleFormComponent,
  AutomationRuleTableComponent,
  AutomationRuleConditionFormComponent,
  AutomationRuleActionFormComponent,
];

@NgModule({
  declarations: [...components],
  imports: [...angularModules, ...lumModules, ColorPickerModule, IconComponent],
  exports: [...components],
  schemas: [NO_ERRORS_SCHEMA],
})
export class AutomationRuleModule {}
